import script from "./HeaderComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderComp.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderComp.vue?vue&type=style&index=0&id=85c529f4&scoped=true&lang=css"

import exportComponent from "D:\\laoyou\\rez-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85c529f4"]])

export default __exports__